module.exports = __webpack_public_path__ + "img/tiktok-icon.c336260d.svg";